import type { ResultSetEntry } from './filtersAreEqual';

export function getResultSetEntry(resultSetId: string): ResultSetEntry {
  const [projectId, proposalId, queryId, dataNodeId, dynamicId] = resultSetId.split('_');

  if (projectId === undefined || queryId === undefined) {
    throw new Error('ResultSetId is missing projectId or queryId');
  }

  return {
    projectId,
    queryId,
    dataNodeId: dataNodeId === '0' ? undefined : dataNodeId,
    dynamicId: dynamicId === '0' ? undefined : dynamicId,
    proposalId: proposalId === 'live' ? undefined : proposalId
  };
}

/**
 * Inverse of `getResultSetEntry`, colocated with it so the two can't silently drift apart: a change to
 * the part order or sentinel values here is right next to the parser that would need the same change.
 */
export function formatResultSetId(entry: ResultSetEntry): string {
  const { projectId, proposalId, queryId, dataNodeId, dynamicId } = entry;
  return [projectId, proposalId ?? 'live', queryId, dataNodeId ?? '0', dynamicId ?? '0'].join('_');
}
